module.exports = __webpack_public_path__ + "static/front2-21f346d027d79c468822ea6dc5b8170f.jpg";